import React, { ReactNode, useState } from "react";

interface Section {
  title: string;
  content: ReactNode[];
  initiallyOpen?: boolean;
  hid?: string; // header ID for linking
}

export const CollapsibleSection: React.FC<Section> = ({ title, content, initiallyOpen, hid }) => {
  const [open, setOpen] = useState(initiallyOpen !== undefined ? initiallyOpen : true);
  return (
    <section>
      <h2 id={hid} onClick={() => setOpen(!open)} style={{ cursor: "pointer" }}>
        {title} {open ? "▲" : "▼"}
      </h2>
      {open ? <div>{content}</div> : (<i>(sekce sbalena)</i>)}
    </section>
  );
};